<div>
  <img class="avatar rounded-circle"
          [src]="url | sanitizeUrl"/>
</div>